import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { BookOpen, Download } from "lucide-react";
import { fileUrl } from "@/lib/api";
import { PdfViewerModal } from "@/components/PdfViewerModal";

export const BookCard = ({ book }) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <div data-testid={`book-card-${book.id}`} className="card-hover bg-white rounded-xl overflow-hidden border border-amber-200/60 shadow-sm flex flex-col">
        <div className="relative aspect-[3/4] bg-gradient-to-br from-[#0a2540] to-[#061729] overflow-hidden">
          {book.cover_url ? (
            <img src={fileUrl(book.cover_url)} alt={book.title} className="w-full h-full object-cover" />
          ) : (
            <div className="w-full h-full flex flex-col items-center justify-center text-amber-300 p-4 text-center">
              <BookOpen size={40} />
              <span className="font-serif-deva text-white mt-3 text-sm line-clamp-3">{book.title}</span>
            </div>
          )}
          {book.category && (
            <span className="absolute top-3 left-3 bg-amber-500 text-white text-xs px-2.5 py-1 rounded-full font-medium">
              {book.category}
            </span>
          )}
        </div>
        <div className="p-4 flex flex-col flex-1">
          <h3 className="font-serif-deva text-lg text-[#0a2540] leading-snug line-clamp-2">{book.title}</h3>
          {book.author && <p className="text-sm text-amber-700 mt-1">— {book.author}</p>}
          {book.publication_info && <p className="text-xs text-slate-500 mt-1 font-eng">{book.publication_info}</p>}
          {book.description && <p className="text-sm text-slate-600 mt-2 line-clamp-3 flex-1">{book.description}</p>}
          <div className="flex gap-2 mt-4">
            <Button
              size="sm"
              data-testid={`book-read-${book.id}`}
              onClick={() => setOpen(true)}
              disabled={!book.pdf_url}
              className="flex-1 bg-[#0a2540] hover:bg-[#061729] gap-1"
            >
              <BookOpen size={15} /> PDF पढ़ें
            </Button>
            <a href={fileUrl(book.pdf_url, true)} target="_blank" rel="noopener noreferrer" className={`flex-1 ${!book.pdf_url && "pointer-events-none opacity-50"}`} data-testid={`book-download-${book.id}`}>
              <Button size="sm" variant="outline" className="w-full border-amber-400 text-amber-700 hover:bg-amber-50 gap-1">
                <Download size={15} /> डाउनलोड
              </Button>
            </a>
          </div>
        </div>
      </div>
      <PdfViewerModal open={open} onOpenChange={setOpen} url={book.pdf_url} title={book.title} />
    </>
  );
};
